import React from "react";
import Navbar from "../navbar/Navbar";
import AboutusImg from "../../../Assets/partner_about_image.jpeg";
import Footer from "../../footer/Footer";
import { Helmet } from "react-helmet-async";

interface AboutCardProps {
  title: string;
  content: string;
}

const AboutCard: React.FC<AboutCardProps> = ({ title, content }) => (
  <div
    className="p-8 rounded-xl text-center shadow-lg transform transition-transform duration-300 hover:scale-105"
    style={{ backgroundColor: "#D9D9D9" }}
  >
    <h3 className="text-3xl md:text-2xl lg:text-3xl font-bold mb-4">
      {title}
    </h3>
    <p>{content}</p>
  </div>
);

const AboutusPage: React.FC = () => {
  const aboutSections = [
    {
      title: "OUR STORY",
      content: "PupHub Partner App was created with one goal in mind — to help pet-related businesses grow and connect with pet parents. Whether you're a grooming service, a vet clinic, a pet creche, or a pet supplies store, this platform provides you with the tools to expand your customer base and streamline your operations. By connecting with the vibrant PupHub community, your business gets the visibility it deserves."
    },
    {
      title: "OUR FACILITY",
      content: "The PupHub Partner App is more than just a platform for connecting with pet parents; it's a comprehensive solution to grow your business. With easy tools for managing appointments, promoting services, and gaining insights, you can focus on what you do best — providing top-notch pet care. Our platform is designed for ease of use, helping you engage with the local pet-loving community quickly and effectively."
    },
    {
      title: "OUR COMMITMENT",
      content: "We're dedicated to supporting every business partner that joins the PupHub community. From providing seamless communication tools to offering insights into local pet needs, we're committed to ensuring your success. Your growth is our growth, and together, we're building a family of pet lovers and service providers that helps each other thrive."
    }
  ];

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://puphub.co.in/partner-aboutus" />
        <title>PupHub Partner | About Us</title>
        <meta
          name="description"
          content="Learn about PupHub Partner and our mission to support pet care businesses"
        />
      </Helmet>
      
      <Navbar />
      
      <div
        className="w-[100vw] h-[30vh] sm:h-[80vh] relative"
        style={{
          backgroundImage: `url(${AboutusImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        role="img"
        aria-label="About PupHub Partner platform"
      />
      
      <div className="m-5">
        <section className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {aboutSections.map((section, index) => (
            <AboutCard
              key={`about-section-${index}`}
              title={section.title}
              content={section.content}
            />
          ))}
        </section>

        <section className="text-center mt-16">
          <p className="text-xl text-white">
            Become a part of the PupHub Partner App today and unlock the
            potential of your pet business. Whether you're seeking new
            customers, improving your operations, or simply getting connected
            with the pet community, we've got you covered. Together, let's
            create a brighter future for pets and pet parents alike!
          </p>
        </section>
      </div>
      
      <Footer />
    </>
  );
};

export default AboutusPage;